import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function HeartFilled(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.854 22.158l-.604-.491C3.336 15.22 1.084 12.859 1.002 9.123.932 5.948 3.24 3.239 6.409 3.018c2.855-.2 4.542 1.345 5.445 2.326.904-.981 2.593-2.526 5.447-2.326 3.168.222 5.476 2.93 5.405 6.106-.082 3.735-2.334 6.098-10.246 12.543l-.606.49z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoHeartFilled = React.memo(HeartFilled);
export default MemoHeartFilled;